import React from "react";
import ForgotPasswordHead from "../../component/AuthHead/ForgotPaswordHead";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  return (
    <div>
      <ForgotPasswordHead />
      <section id="service-details" className="service-details">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 mobcol">
            <div className="col-lg-12">
              <Container style={{ width: "50%" }}>
                <Form>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" />
                  </Form.Group>

                  <Button className="battoun">Reset Password</Button>
                  <Link to={"/login"}>
                    <p
                      style={{
                        textAlign: "right",
                        fontSize: "12px",
                        paddingTop: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      Login
                    </p>
                  </Link>
                </Form>
              </Container>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgotPassword;
